import React from "react";
import { Text } from "react-native";
import { useSelector } from "react-redux";
import { translateText } from "../../translations/translationService";
import { TEXT_COLORS } from "../../style/colors.js";

const HeaderTitle = ({ textKey }) => {
  const lang = useSelector((state) => state.lang.value);

  return (
    <Text
      style={{
        fontSize: 20,
        fontWeight: "700",
        color: TEXT_COLORS.LIGHT,
        fontFamily: "System",
        letterSpacing: 0.3,
      }}>
      {translateText(textKey, lang)}
    </Text>
  );
};

export default HeaderTitle;
